const LayoutDefault = () =>
  import(/* webpackChunkName: "kp" */ '@/layouts/LayoutDefault.vue');
const LayoutData = () =>
  import(/* webpackChunkName: "kp" */ '@/layouts/LayoutData.vue');
const Dashboard = () =>
  import(/* webpackChunkName: "kp" */ '@/views/pelayanan/Index.vue');
const Stock = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/stock/Index.vue'
  );
const ManajemenBatch = () =>
  import(
    /* webpackChunkName: "admin-gudang-stock" */ '@/views/pusat/gudang/stock/manajemen-batch/Index.vue'
  );

const PenerimaanBarangDariPusat = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/penerimaan/barang-dari-pusat/Index.vue'
  );
const PenerimaanReimbursement = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/penerimaan/Reimbursement.vue'
  );
const PenerimaanSusulanPromo = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/penerimaan/SusulanPromo.vue'
  );

const Restock = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/restock/Index.vue'
  );
const TambahRestock = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/restock/Tambah.vue'
  );

/**
 * Pengiriman
 */

// Pengiriman Retur
const ReturKePusat = () =>
  import(
    /* webpackChunkName: "kp-pengiriman" */ '@/views/pelayanan/gudang/pengiriman/retur-ke-pusat/Index.vue'
  );
const TambahReturKePusat = () =>
  import(
    /* webpackChunkName: "kp-pengiriman" */ '@/views/pelayanan/gudang/pengiriman/retur-ke-pusat/Tambah.vue'
  );

// Pengiriman ke SC
const PengirimanBarangkeStockistDikirim = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengiriman" */ '@/views/pelayanan/gudang/pengiriman/barang-ke-stockist-dikirim/Index.vue'
  );
const PengirimanBarangkeStockistDiambil = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengiriman" */ '@/views/pelayanan/gudang/pengiriman/barang-ke-stockist-diambil/Index.vue'
  );
const TambahPengirimanBarangkeStockist = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengiriman" */ '@/views/pelayanan/gudang/pengiriman/barang-ke-stockist/Tambah.vue'
  );
// pengiriman ke SC
const PengirimanBarangKeSCDiambil = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengiriman" */ '@/views/pelayanan/gudang/pengiriman/barang-ke-sc-diambil/Index.vue'
  );
const PengirimanBarangKeSCDikirim = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengiriman" */ '@/views/pelayanan/gudang/pengiriman/barang-ke-sc-dikirim/Index.vue'
  );
const TambahPengirimanBarangKeSC = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengiriman" */ '@/views/pelayanan/gudang/pengiriman/barang-ke-sc/Tambah.vue'
  );

/**
 * Pengeluaran
 */
// Pengeluaran ke SC
const PengeluaranBarangKeStockistDikirim = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengeluaran" */ '@/views/pelayanan/gudang/pengeluaran/barang-ke-stockist-dikirim/Index.vue'
  );
const PengeluaranBarangKeStockistDiambil = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengeluaran" */ '@/views/pelayanan/gudang/pengeluaran/barang-ke-stockist-diambil/Index.vue'
  );
const PengeluaranRestockBarangKeStockistDikirim = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengeluaran" */ '@/views/pelayanan/gudang/pengeluaran/restock-barang-ke-stockist-dikirim/Index.vue'
  );
const PengeluaranRestockBarangKeStockistDiambil = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengeluaran" */ '@/views/pelayanan/gudang/pengeluaran/restock-barang-ke-stockist-diambil/Index.vue'
  );
const DetailPengeluaranBarangKeStockist = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengeluaran" */ '@/views/pelayanan/gudang/pengeluaran/barang-ke-stockist/DetailPengiriman.vue'
  );
const PengemasanBarangKeStockist = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengeluaran" */ '@/views/pelayanan/gudang/pengeluaran/barang-ke-stockist/Pengemasan.vue'
  );
// pengeluaran ke sc
const PengeluaranKeSCDikirim = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengeluaran" */ '@/views/pelayanan/gudang/pengeluaran/barang-ke-sc-dikirim/Index.vue'
  );
const PengeluaranKeSCDiambil = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengeluaran" */ '@/views/pelayanan/gudang/pengeluaran/barang-ke-sc-diambil/Index.vue'
  );
const DetailPengeluaranBarangKeSC = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengeluaran" */ '@/views/pelayanan/gudang/pengeluaran/barang-ke-sc/DetailPengiriman.vue'
  );
const PengemasanBarangKeSC = () =>
  import(
    /* webpackChunkName: "admin-gudang-pengeluaran" */ '@/views/pelayanan/gudang/pengeluaran/barang-ke-sc/Pengemasan.vue'
  );

/**
 * Susulan
 */
// Susulan ke SC
const SusulanBarangKeSC = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/susulan/barang-ke-sc/Index.vue'
  );
const TambahSusulanBarangKeSC = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/susulan/barang-ke-sc/Tambah.vue'
  );
const PengemasanSusulanBarangKeSC = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/susulan/barang-ke-sc/Detail.vue'
  );

// Susulan ke Stockist
const SusulanBarangKeStockist = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/susulan/barang-ke-stockist/Index.vue'
  );
const TambahSusulanBarangKeStockist = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/susulan/barang-ke-stockist/Tambah.vue'
  );
const PengemasanSusulanBarangKeStockist = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/susulan/barang-ke-stockist/Detail.vue'
  );

const FakturKP = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/faktur-kp/Index.vue'
  );
const Laporan = () =>
  import(/* webpackChunkName: "kp" */ '@/views/pelayanan/Laporan.vue');

// Setup
const Setup = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/setup/Index.vue'
  );

const ReturPusat = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/retur/pusat/Index.vue'
  );
const TambahReturPusat = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/retur/pusat/Tambah.vue'
  );

const PengirimanEkspedisi = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/pengiriman-ekspedisi/Index.vue'
  );
const TambahPengirimanEkspedisi = () =>
  import(
    /* webpackChunkName: "kp" */ '@/views/pelayanan/gudang/pengiriman-ekspedisi/Tambah.vue'
  );
const CekFaktur = () =>
  import(
    /* webpackChunkName: "admin" */ '@/views/CekFaktur.vue'
  );

let root = '/gudang';

export default [
  {
    path: root + '/',
    component: Dashboard,
    meta: {
      auth: true,
      title: 'Dashboard | Kantor Pelayanan',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/cek-faktur',
    component: CekFaktur,
    meta: {
      auth: true,
      title: 'Cek Faktur',
      layout: LayoutDefault,
    },
  },
  // Restock
  {
    path: root + '/restock/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Restock',
    },
    children: [
      {
        path: '',
        name: 'restock',
        component: Restock,
        meta: {
          auth: true,
          title: 'Restock',
          layout: LayoutDefault,
          breadcrumb: 'Restock',
        },
      },
      {
        path: 'tambah',
        name: 'restock.tambah',
        component: TambahRestock,
        meta: {
          auth: true,
          title: 'Tambah Restock',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Restock',
        },
      },
      {
        path: ':id',
        name: 'restock.edit',
        component: TambahRestock,
        meta: {
          auth: true,
          title: 'Tambah Restock',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Restock',
        },
      },
    ]
  },
  // Barang Masuk
  {
    path: root + '/penerimaan-barang-dari-pusat',
    component: PenerimaanBarangDariPusat,
    meta: {
      auth: true,
          title: 'Penerimaan Barang Masuk | Gudang',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/penerimaan-rembursement',
    component: PenerimaanReimbursement,
    meta: {
      auth: true,
          title: 'Penerimaan Reimbursement | Gudang',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/penerimaan-promo',
    component: PenerimaanSusulanPromo,
    meta: {
      auth: true,
          title: 'Penerimaan Susulan Promo | Gudang',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/stock/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Stock',
    },
    children: [
      {
        path: 'stocks',
        component: Stock,
        meta: {
          auth: true,
          title: 'Stock | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: 'batch',
        component: ManajemenBatch,
        meta: {
          auth: true,
          title: 'Manajemen Batch | Gudang',
          layout: LayoutDefault,
        },
      },
    ],
  },
  // Pengiriman
  // Pengiriman ke SC
  {
    path: root + '/pengiriman/barang-ke-stockist-dikirim/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengiriman Barang ke Stockist Dikirim',
    },
    children: [
      {
        path: '',
        component: PengirimanBarangkeStockistDikirim,
        meta: {
          auth: true,
          title: 'Pengiriman Barang ke Stockist Dikirim | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id',
        component: TambahPengirimanBarangkeStockist,
        name: 'gudang.pengiriman.barang-ke-stockist-dikirim.detail',
        meta: {
          auth: true,
          title: 'Tambah Pengiriman Barang ke Stockist Dikirim | Gudang',
          layout: LayoutDefault,
        },
        props: {
          indexPath: '/gudang/pengiriman/barang-ke-stockist-dikirim'
        }
      },
    ],
  },
  {
    path: root + '/pengiriman/barang-ke-stockist-diambil/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengiriman Barang ke Stockist Diambil',
    },
    children: [
      {
        path: '',
        component: PengirimanBarangkeStockistDiambil,
        meta: {
          auth: true,
          title: 'Pengiriman Barang ke Stockist Diambil | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id',
        component: TambahPengirimanBarangkeStockist,
        name: 'gudang.pengiriman.barang-ke-stockist-diambil.detail',
        meta: {
          auth: true,
          title: 'Tambah Pengiriman Barang ke Stockist Diambil | Gudang',
          layout: LayoutDefault,
        },
        props: {
          indexPath: '/gudang/pengiriman/barang-ke-stockist-diambil'
        },
      }
    ],
  },
  {
    path: root + '/pengiriman/barang-ke-sc-diambil/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengiriman Barang ke SC Diambil',
    },
    children: [
      {
        path: '',
        component: PengirimanBarangKeSCDiambil,
        meta: {
          auth: true,
          title: 'Pengiriman Barang ke SC Diambil | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id',
        component: TambahPengirimanBarangKeSC,
        name: 'gudang.pengiriman.barang-ke-sc-diambil.detail',
        meta: {
          auth: true,
          title: 'Tambah Pengiriman Barang ke SC Diambil | Gudang',
          layout: LayoutDefault,
        },
        props: {
          indexPath: '/gudang/pengiriman/barang-ke-sc-diambil'
        },
      },
    ],
  },
  {
    path: root + '/pengiriman/barang-ke-sc-dikirim/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengiriman Barang ke SC Dikirim',
    },
    children: [
      {
        path: '',
        component: PengirimanBarangKeSCDikirim,
        meta: {
          auth: true,
          title: 'Pengiriman Barang ke SC Dikirim | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id',
        component: TambahPengirimanBarangKeSC,
        name: 'gudang.pengiriman.barang-ke-sc-dikirim.detail',
        meta: {
          auth: true,
          title: 'Tambah Pengiriman Barang ke SC Dikirim | Gudang',
          layout: LayoutDefault,
        },
        props: {
          indexPath: '/gudang/pengiriman/barang-ke-sc-dikirim'
        },
      },
    ],
  },
  {
    path: root + '/pengiriman/retur-ke-pusat',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengiriman Retur ke Pusat',
    },
    children: [
      {
        path: '',
        component: ReturKePusat,
        meta: {
          auth: true,
          title: 'Pengiriman Retur Barang ke Pusat | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id',
        component: TambahReturKePusat,
        meta: {
          auth: true,
          title: 'Pengiriman Retur Barang ke Pusat | Gudang',
          layout: LayoutDefault,
        },
      },
    ],
  },

  {
    path: root + '/pengeluaran/retur',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengiriman Retur ke Pusat',
    },
    children: [
      {
        path: '',
        component: ReturKePusat,
        meta: {
          auth: true,
          title: 'Pengiriman Retur Barang ke Pusat | Gudang',
          layout: LayoutDefault,
        },
      },
    ],
  },
  /**
   *
   *
   * Pengeluaran
   *
   */

  /**
   * Pengeluaran Stockist
   */
  {
    path: root + '/pengeluaran/barang-ke-stockist-dikirim/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengeluaran Barang ke Stockist',
    },
    children: [
      {
        path: '',
        component: PengeluaranBarangKeStockistDikirim,
        meta: {
          auth: true,
          title: 'Pengeluaran Barang ke Stockist Dikirim | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Detail Pengeluaran Barang ke Stockist Dikirim',
        },
        children: [
          {
            path: '',
            component: DetailPengeluaranBarangKeStockist,
            name: 'gudang.pengeluaran.barang-ke-stockist-dikirim.detail',
            meta: {
              auth: true,
              title: 'Detail Pengeluaran Barang ke Stockist Dikirim | Gudang',
              layout: LayoutDefault,
            },
            props: {
              indexPath: '/gudang/pengeluaran/barang-ke-stockist-dikirim'
            }
          },
          {
            path: 'pengemasan',
            component: PengemasanBarangKeStockist,
            meta: {
              auth: true,
              title: 'Pengemasan Barang | Gudang',
              layout: LayoutDefault,
              breadcrumb: 'Pengemasan Barang ke Stockist Dikirim',
            },
            props: {
              indexPath: '/gudang/pengeluaran/barang-ke-stockist-dikirim',
              prevRoute: 'gudang.pengeluaran.barang-ke-stockist-dikirim.detail'
            }
          }
        ],
      },
    ],
  },
  {
    path: root + '/pengeluaran/barang-ke-stockist-diambil/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengeluaran Barang ke Stockist',
    },
    children: [
      {
        path: '',
        component: PengeluaranBarangKeStockistDiambil,
        meta: {
          auth: true,
          title: 'Pengeluaran Barang ke Stockist Diambil | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Detail Pengeluaran Barang ke Stockist Diambil',
        },
        children: [
          {
            path: '',
            component: DetailPengeluaranBarangKeStockist,
            name: 'gudang.pengeluaran.barang-ke-stockist-diambil.detail',
            meta: {
              auth: true,
              title: 'Detail Pengeluaran Barang ke Stockist Diambil | Gudang',
              layout: LayoutDefault,
            },
            props: {
              indexPath: '/gudang/pengeluaran/barang-ke-stockist-diambil'
            }
          },
          {
            path: 'pengemasan',
            component: PengemasanBarangKeStockist,
            meta: {
              auth: true,
              title: 'Pengemasan Barang | Gudang',
              layout: LayoutDefault,
              breadcrumb: 'Pengemasan Barang ke Stockist Diambil',
            },
            props: {
              indexPath: '/gudang/pengeluaran/barang-ke-stockist-diambil',
              prevRoute: 'gudang.pengeluaran.barang-ke-stockist-diambil.detail'
            }
          },
        ],
      },
    ],
  },
  {
    path: root + '/pengeluaran/barang-ke-sc-dikirim/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengeluaran Barang ke SC',
    },
    children: [
      {
        path: '',
        component: PengeluaranKeSCDikirim,
        meta: {
          auth: true,
          title: 'Pengeluaran Barang ke SC Dikirim | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Detail Pengeluaran Barang ke SC Dikirim',
        },
        children: [
          {
            path: '',
            name: 'gudang.pengeluaran.barang-ke-sc-dikirim.detail',
            component: DetailPengeluaranBarangKeSC,
            meta: {
              auth: true,
              title: 'Detail Pengeluaran Barang SC Dikirim | Gudang',
              layout: LayoutDefault
            },
            props: {
              indexPath: '/gudang/pengeluaran/barang-ke-sc-dikirim'
            }
          },
          {
            path: 'pengemasan',
            component: PengemasanBarangKeSC,
            meta: {
              auth: true,
              title: 'Pengemasan Barang | Gudang',
              layout: LayoutDefault,
              breadcrumb: 'Pengemasan Barang ke SC Dikirim',
            },
            props: {
              indexPath: '/gudang/pengeluaran/barang-ke-sc-dikirim',
              prevRoute: 'gudang.pengeluaran.barang-ke-sc-dikirim.detail',
            }
          },
        ],
      },
    ],
  },
  {
    path: root + '/pengeluaran/barang-ke-sc-diambil/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengeluaran Barang ke SC',
    },
    children: [
      {
        path: '',
        component: PengeluaranKeSCDiambil,
        meta: {
          auth: true,
          title: 'Pengeluaran Barang ke SC Diambil | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Detail Pengeluaran Barang ke SC Diambil',
        },
        children: [
          {
            path: '',
            component: DetailPengeluaranBarangKeSC,
            name: 'gudang.pengeluaran.barang-ke-sc-diambil.detail',
            meta: {
              auth: true,
              title: 'Detail Pengeluaran Barang SC Diambil | Gudang',
              layout: LayoutDefault
            },
            props: {
              indexPath: '/gudang/pengeluaran/barang-ke-sc-diambil'
            },
          },
          {
            path: 'pengemasan',
            component: PengemasanBarangKeSC,
            meta: {
              auth: true,
              title: 'Pengemasan Barang | Gudang',
              layout: LayoutDefault,
              breadcrumb: 'Pengemasan Barang ke SC Diambil',
            },
            props: {
              indexPath: '/gudang/pengeluaran/barang-ke-sc-diambil',
              prevRoute: 'gudang.pengeluaran.barang-ke-sc-diambil.detail'
            },
          },
        ],
      },
    ],
  },
  {
    path: root + '/pengeluaran/restock-barang-ke-stockist-dikirim/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengeluaran Restock Barang ke Stockist',
    },
    children: [
      {
        path: '',
        component: PengeluaranRestockBarangKeStockistDikirim,
        meta: {
          auth: true,
          title: 'Pengeluaran Restock Barang ke Stockist Dikirim | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Detail Pengeluaran Restock Barang ke Stockist Dikirim',
        },
        children: [
          {
            path: '',
            component: DetailPengeluaranBarangKeStockist,
            name: 'gudang.pengeluaran.restock-barang-ke-stockist-dikirim.detail',
            meta: {
              auth: true,
              title: 'Detail Pengeluaran Restock Barang ke Stockist Dikirim | Gudang',
              layout: LayoutDefault,
            },
            props: {
              indexPath: '/gudang/pengeluaran/restock-barang-ke-stockist-dikirim'
            }
          },
          {
            path: 'pengemasan',
            component: PengemasanBarangKeStockist,
            meta: {
              auth: true,
              title: 'Pengemasan Barang | Gudang',
              layout: LayoutDefault,
              breadcrumb: 'Pengemasan Barang ke Stockist Dikirim',
            },
            props: {
              indexPath: '/gudang/pengeluaran/restock-barang-ke-stockist-dikirim'
            }
          }
        ],
      },
    ],
  },
  {
    path: root + '/pengeluaran/restock-barang-ke-stockist-diambil/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengeluaran Restock Barang ke Stockist',
    },
    children: [
      {
        path: '',
        component: PengeluaranRestockBarangKeStockistDiambil,
        meta: {
          auth: true,
          title: 'Pengeluaran Restock Barang ke Stockist Diambil | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Detail Pengeluaran Restock Barang ke Stockist Diambil',
        },
        children: [
          {
            path: '',
            component: DetailPengeluaranBarangKeStockist,
            name: 'gudang.pengeluaran.restock-barang-ke-stockist-diambil.detail',
            meta: {
              auth: true,
              title: 'Detail Pengeluaran Restock Barang ke Stockist Diambil | Gudang',
              layout: LayoutDefault,
            },
            props: {
              indexPath: '/gudang/pengeluaran/restock-barang-ke-stockist-diambil'
            }
          },
          {
            path: 'pengemasan',
            component: PengemasanBarangKeStockist,
            meta: {
              auth: true,
              title: 'Pengemasan Barang | Gudang',
              layout: LayoutDefault,
              breadcrumb: 'Pengemasan Barang ke Stockist Diambil',
            },
            props: {
              indexPath: '/gudang/pengeluaran/restock-barang-ke-stockist-diambil'
            }
          },
        ],
      },
    ],
  },
  {
    path: root + '/setup/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Setup',
    },
    children: [
      {
        path: '',
        component: Setup,
        meta: {
          auth: true,
          title: 'Setup | Gudang',
          layout: LayoutDefault,
        },
      },
    ],
  },

  /**
   * Susulan
   */
  {
    path: root + '/susulan/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Susulan',
    },
    children: [
      {
        path: 'barang-ke-stockist/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Pengiriman Susulan ke Stockist',
        },
        children: [
          {
            path: '',
            component: SusulanBarangKeStockist,
            name: 'gudang.susulan.barang-ke-stockist',
            meta: {
              auth: true,
              title: 'Pengiriman Susulan ke Stockist | Gudang',
              layout: LayoutDefault,
            },
          },
          {
            path: ':id',
            component: TambahSusulanBarangKeStockist,
            name: 'gudang.susulan.barang-ke-stockist.detail',
            meta: {
              auth: true,
              title: 'Tambah Pengiriman Susulan ke Stockist | Gudang',
              layout: LayoutDefault,
              breadcrumb: 'Pengiriman Susulan ke Stockist',
            },
            props: {
              indexPath: '/gudang/susulan/barang-ke-stockist'
            }
          },
          {
            path: ':id/pengemasan',
            component: PengemasanSusulanBarangKeStockist,
            name: 'gudang.susulan.barang-ke-stockist.tambah',
            meta: {
              auth: true,
              title: 'Pengemasan Susulan ke Stockist | Gudang',
              layout: LayoutDefault,
              breadcrumb: 'Pengemasan Susulan ke Stockist',
            },
          },
        ],
      },
      {
        path: 'barang-ke-sc/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Pengiriman Susulan ke SC',
        },
        children: [
          {
            path: '',
            component: SusulanBarangKeSC,
            name: 'gudang.susulan.barang-ke-sc',
            meta: {
              auth: true,
              title: 'Pengiriman Susulan ke SC | Gudang',
              layout: LayoutDefault,
            },
          },
          {
            path: ':id',
            component: TambahSusulanBarangKeSC,
            name: 'gudang.susulan.barang-ke-sc.detail',
            meta: {
              auth: true,
              title: 'Tambah Pengiriman Susulan ke SC | Gudang',
              layout: LayoutDefault,
              breadcrumb: 'Pengiriman Susulan ke SC',
            },
            props: {
              indexPath: '/gudang/susulan/barang-ke-sc'
            }
          },
          {
            path: ':id/pengemasan',
            component: PengemasanSusulanBarangKeSC,
            name: 'gudang.susulan.barang-ke-sc.tambah',
            meta: {
              auth: true,
              title: 'Pengemasan Susulan ke SC | Gudang',
              layout: LayoutDefault,
              breadcrumb: 'Pengemasan Susulan ke SC',
            },
          },
        ],
      },
    ],
  },

  // Faktur KP
  {
    path: root + '/faktur-kp',
    component: FakturKP,
    meta: {
      auth: true,
      title: 'Faktur KP | Kantor Pelayanan',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/laporan',
    component: Laporan,
    meta: {
      auth: true,
      title: 'Laporan Page | Kantor Pelayanan',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/retur/pusat',
    component: LayoutData,
    meta: {
      breadcrumb: 'Retur',
    },
    children: [
      {
        path: '',
        component: ReturPusat,
        name: 'index.retur.pusat',
        meta: {
          auth: true,
          title: 'Retur ke Pusat | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-retur',
        component: TambahReturPusat,
        name: 'create.retur.pusat',
        meta: {
          auth: true,
          title: 'Tambah Retur ke Pusat | Gudang',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Retur',
        },
      },
      {
        path: 'tambah-retur/:id',
        component: TambahReturPusat,
        name: 'edit.retur.pusat',
        meta: {
          auth: true,
          title: 'Edit Retur ke Pusat | Gudang',
          layout: LayoutDefault,
        },
      },
    ],
  },
  {
    path: root + '/pengiriman-ekspedisi/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Pengiriman Ekspedisi',
    },
    children: [
      {
        path: '',
        component: PengirimanEkspedisi,
        name: 'pengiriman-ekspedisi',
        meta: {
          auth: true,
          title: 'Pengiriman Ekspedisi | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: ':id',
        component: TambahPengirimanEkspedisi,
        name: 'pengiriman-ekspedisi.tambah',
        meta: {
          auth: true,
          title: 'Tambah Pengiriman Ekspedisi | Gudang',
          layout: LayoutDefault,
        },
      },
    ],
  },
];
